export default "__VITE_ASSET__b80bc6bb__"